import * as z from "zod";

export const returnDestinationSource = z.enum([
  "locationFlow",
  "consolidationShipTo",
]);

export const returnDestinationOutput = z.object({
  /** ISO alpha-2. */
  country: z.string(),
  sources: z.array(returnDestinationSource),
});

export const getReturnDestinations = {
  name: "getReturnDestinations" as const,
  input: z.null(),
  output: z.object({ destinations: z.array(returnDestinationOutput) }),
};

export type ReturnDestination = z.infer<typeof returnDestinationOutput>;
